// extracted by mini-css-extract-plugin
module.exports = {"pricingSideBySide":"PricingSideBySide_pricingSideBySide__bLM8q global_grid__4e_JW","container":"PricingSideBySide_container__gWzrF"};